/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Modal, TextField, useTheme } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { toast, ToastContainer } from "react-toastify";
import {
  setActiveEnvironment,
  setActiveTeam,
  setTeamProjectList,
  setTeams,
  setTeamActiveProject,
  // updateCollectionObject,
  setCurrentUser,
  // setThemeRefetchTrigger,
  setDateFormat,
  setRecordsPerPage,
  setCompanyDetails,
} from "@/features/Global/slice";
import { ApiCollectionEnvApi } from "../../features/ApiCollection/envApi";
import { useGetCompanyDetailsQuery } from "@/features/Global/api";
import { store } from "@/app/store";
import { useGetProjectsByTeamIdQuery } from "@/features/ApiCollection/workSpaceApi";
import { Header } from "./Header";
import { modalStyle } from "@/Misc/modalStyle";
import cacheManager from "@/utils/cacheManager";
import { setRoleCodeDetails } from "@/features/RoleAuthMgmt/slice";
import { setRoleCodeDetails as setRoleCodeDetailsGlobal } from "@/features/Global/slice";
import i18n from "@/Misc/i18nConfig";
import PhantomLoader from "../Common/phantomLoader";
import { useNavigate } from "react-router-dom";

LicenseInfo.setLicenseKey(
  "763cc31f473bc5d1672d2c77ba8dccaeTz0xMDk4OTQsRT0xNzczODc4Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

interface MainLayoutProps {
  children: React.ReactNode;
  parentData?: any;
  isChild?: boolean;
  parentTheme?: string;
  themeRefetchTrigger?: (count: Number) => void;
  refetchTeamsParent?: () => void;
  refetchProjectsParent?: () => void;
  reactFlow?: any;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  parentData,
  isChild,
  themeRefetchTrigger,
  refetchTeamsParent,
  refetchProjectsParent,
}) => {
  const dispatch = useAppDispatch();
  const {
    activeTeam,
    activeProject,
    activeEnvironment,
    refetchEnv,
    // refetchTeams,
    // refetchProjects,
  } = useAppSelector((state) => state.appGlobal);
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: projectsData, isLoading } = useGetProjectsByTeamIdQuery(
    activeTeam?._id,
    {
      skip: !activeTeam || isChild,
    }
  );

  const { data: companyData } = useGetCompanyDetailsQuery({});

  useEffect(() => {
    if (companyData?.data?.decryptedData) {
      dispatch(setCompanyDetails(companyData.data.decryptedData));
    }
  }, [companyData, dispatch]);

  // const { data: envData, refetch: envDataRefetch } =
  //   useGetEnvironmentByWorkspaceIdQuery(
  //     {
  //       workspaceId: activeProject?.workspaceId,
  //     },
  //     { skip: !activeProject }
  //   );

  useEffect(() => {
    if (isChild && parentData?.language) {
      localStorage.setItem("language", parentData.language);
      i18n.changeLanguage(parentData.language);
    }
  }, [isChild, parentData?.language]);

  // useEffect(() => {
  //   if (isChild && themeRefetchTrigger) {
  //     dispatch(setThemeRefetchTrigger(themeRefetchTrigger));
  //   }
  // }, [isChild, themeRefetchTrigger]);

  // useEffect(() => {
  //   if (refetchTeams) {
  //     refetchTeamsParent?.();
  //   }
  // }, [refetchTeams]);

  // useEffect(() => {
  //   if (refetchProjects) {
  //     refetchProjectsParent?.();
  //   }
  // }, [refetchProjects]);

  useEffect(() => {
    const initializeData = async () => {
      if (!isChild) {
        try {
          // Fetch assigned teams
          // const response = await fetch(
          //   import.meta.env.VITE_API_BASE_URL +
          //     "/company-mgmt/team-mgmt/assigned-team",
          //   {
          //     headers: {
          //       "x-api-key": import.meta.env.VITE_COMPANY_API_KEY,
          //       accessToken: localStorage.getItem("accessToken") || "",
          //     },
          //   }
          // );
          // const teamsData = await response.json();
          // if (teamsData && teamsData.data.decryptedData.items.length > 0) {
          //   dispatch(setTeams(teamsData.data.decryptedData.items));
          //   dispatch(setActiveTeam(teamsData.data.decryptedData.items[0]));
          // }
        } catch (error) {
          toast.error("Failed to fetch teams");
        }
      } else if (isChild && parentData?.activeTeam) {
        dispatch(setRoleCodeDetails(parentData?.roleCodeDetails));
        dispatch(setRoleCodeDetailsGlobal(parentData?.roleCodeDetails));
        dispatch(
          setActiveEnvironment({
            environment: parentData?.activeEnvironment as any,
          })
        );
        dispatch(setActiveTeam(parentData?.activeTeam));
        dispatch(setCurrentUser(parentData?.currentUser));
        dispatch(
          setTeamActiveProject({
            teamId: parentData?.activeTeam.teamId,
            project: parentData?.activeProject as any,
          })
        );
      } else {
        dispatch(setRoleCodeDetails(parentData?.roleCodeDetails));
        dispatch(setRoleCodeDetailsGlobal(parentData?.roleCodeDetails));
        dispatch(setCurrentUser(parentData?.currentUser));
      }
    };

    initializeData();
  }, [isChild, dispatch, parentData]);

  // Fetch projects when active team changes
  useEffect(() => {
    if (projectsData && activeTeam?.teamId) {
      dispatch(setTeamProjectList({ projects: projectsData }));
      if (!parentData && projectsData.length > 0) {
        dispatch(
          setTeamActiveProject({
            teamId: activeTeam.teamId,
            project: projectsData[0],
          })
        );
        // dispatch(
        //   updateCollectionObject({
        //     projectId: projectsData[0].workspaceId,
        //     value: { activeCollection: null },
        //   })
        // );
      }
    }
  }, [projectsData, dispatch, parentData, activeTeam?.teamId]);

  // Fetch environments when active project changes
  // useEffect(() => {
  //   if (envData && Array.isArray(envData)) {
  //     dispatch(
  //       setEnvList({
  //         environments: envData.map((el) => ({
  //           ...el,
  //           itemId: el.appEnvId,
  //           itemName: el.envName,
  //           itemCatagory: "ENVIRONMENT",
  //         })),
  //       })
  //     );
  //     if (!parentData && envData.length > 0) {
  //       dispatch(setActiveEnvironment({ environment: envData[0] }));
  //     }
  //   }
  // }, [envData, dispatch, parentData]);

  const [showAc, setShowAc] = useState(false);
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );

  useEffect(() => {
    if (parentData) {
      const globalData = store.getState().appGlobal;

      if (
        parentData.activeTeam &&
        (!globalData.activeTeam ||
          globalData.activeTeam._id !== parentData.activeTeam._id)
      ) {
        dispatch(setActiveTeam(parentData.activeTeam));
      }
    }
  }, [parentData, dispatch]);

  const handleMapEnvironmentData = async () => {
    if (!activeEnvironment?.appEnvId) return;

    try {
      const envVariables = await dispatch(
        ApiCollectionEnvApi.endpoints.getEnvVariablesByEnvId.initiate(
          activeEnvironment.appEnvId
        )
      );
      if (Array.isArray(envVariables.data)) {
        dispatch(
          setActiveEnvironment({
            environment: {
              ...activeEnvironment,
              variables: envVariables.data,
            },
          })
        );
      }
    } catch (error) {
      console.error("error", error);
      toast.error("Error fetching environment variables");
    }
  };

  useEffect(() => {
    if (activeEnvironment?.appEnvId) {
      handleMapEnvironmentData();
    }
  }, [activeEnvironment?.appEnvId]);

  // useEffect(() => {
  //   if (refetchEnv) {
  //     // envDataRefetch();
  //     dispatch(setRefetchEnv(false));
  //   }
  // }, [refetchEnv]);

  useEffect(() => {
    if (parentData?.dateFormat) {
      dispatch(setDateFormat(parentData?.dateFormat));
    }
    if (parentData?.recordsPerPage) {
      dispatch(setRecordsPerPage(parentData?.recordsPerPage));
    }
  }, [parentData]);

  if (isChild && !parentData) {
    return null;
  }

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {!isChild ? <Header setShowAc={setShowAc} /> : null}
      {isChild ? (
        <ToastContainer
          theme={theme.palette.mode}
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          style={{
            justifyContent: "flex-start",
          }}
        />
      ) : null}

      {!isChild ? (
        <Modal open={showAc} onClose={() => setShowAc(false)}>
          <Box
            sx={{ ...modalStyle, width: "90%", maxWidth: 600 }}
            // onClick={(e) => {
            //   e.stopPropagation();
            // }}
          >
            <Box
              component={"form"}
              onSubmit={async (e) => {
                e.preventDefault();
                await cacheManager.clear();
                localStorage.clear();
                localStorage.setItem("accessToken", accessToken);
                navigate("/");
                setShowAc(false);
              }}
            >
              <TextField
                multiline
                fullWidth
                value={accessToken}
                onChange={(e) => setAccessToken(() => e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.shiftKey === false) {
                    e.preventDefault();
                  }
                }}
                id="snr-ai-MainLayout-accessToken"
              />
              <Box display={"flex"} justifyContent={"flex-end"} p={1}>
                <Button
                  type={"submit"}
                  variant="contained"
                  id="snr-ai-MainLayout-saveButton"
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      ) : null}
      <Box
        sx={{
          flex: 1,
          height: !isChild ? "calc(100vh - 55px)" : "100vh",
        }}
      >
        {isLoading ? <PhantomLoader /> : children}
      </Box>
    </Box>
  );
};

export default MainLayout;
